export const labTestOptions = [
  { label: "Complete Blood Count (CBC)", value: "cbc" },
  { label: "Basic Metabolic Panel", value: "bmp" },
  { label: "Lipid Panel", value: "lipid_panel" },
  { label: "Thyroid Function Test", value: "thyroid_function" },
  { label: "Liver Function Test", value: "liver_function" },
  { label: "Kidney Function Test", value: "kidney_function" },
  { label: "HbA1c", value: "hba1c" },
  { label: "Urine Analysis", value: "urine_analysis" },
];
